import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { avarage } from '../utilities/_helpers'
import {useUserStore} from './UserStore.js'
import _ from "lodash"
export const useEducationStore = defineStore('EducationStore', {
    state: () => {
        return {
            image:ref(),
            route: useRoute(),
            router: useRouter(),
            file: ref(),
            fileName:ref(),
            originImage:ref(),
            video:reactive({
                active_video:'',
                lesson_desc:'',
                video_name:'',
                active:{}
            }),
            last_played:reactive({}),
            watched_videos:reactive({}),
            loaded:ref(false),
            content:reactive({}),
            reviewed:ref(false),
            userStore:useUserStore(),
            authors:reactive({}),
            author:ref(),
            avarage:avarage,
            rating:reactive({
                total:null,
                count:null
            }),
            avarage_rating:ref(0),
            isOpenDialog:ref(false),
            userSelected:ref(0),
            items: ref([]),
            currentPage : ref(1),
            itemPerPage : ref(5),
            isLoading : ref(false),
            totalWatch : ref(0),

        }
    },
    persist: {
        paths: ['states'],
        debug: false
    },
    actions: {
        converter(canvas) {
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
        },
        async loadVideo(videoSlug){
            let $this = this;
            const route = this.router.resolve({
                name:'lecture-video',
                params:{
                    video:videoSlug
                }
            });
            axios.post(
                route.href
            ).then(function(response) {
                if(response.data.error != true){
                    $this.video.active_video = response.data.data.content;
                    $this.video.lesson_desc = response.data.data.description;
                    $this.video.video_name = response.data.data.slug
                    $this.video.active = response.data.data
                    $this.last_played = response.data.data
                    return;
                }
                toastr.error(response.data.message, $this.content.title);
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    console.error(error.response.data.response_msg);
                }, 2000)
            });
        },
        async updateUserVidProgress(videoSlug,durationCovered){
            let $this = this;
            const route = this.router.resolve({
                name:'save-course-progress',
                params:{
                    video:videoSlug
                }
            });
            axios.post(
                route.href,{video_time_watched:durationCovered}
            ).then(function(response) {
                if(response.data.error != true){
                    return;
                }
                toastr.error(response.data.message, $this.content.title);
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    toastr.error(error.response.data.response_msg, 'Error!');
                }, 2000)
            });
        },
        async getLastPlayedVideo(course){
            let $this = this;
            const route = this.router.resolve({
                name:'last-played-video',
                params:{
                    course:course
                }
            });
            axios.post(
                route.href
            ).then(function(response) {
                if(response.data.error != true){
                    $this.last_played = response.data?.data
                    if(!_.isNull($this.last_played)){
                        $this.loadVideo($this.last_played.slug)
                    }
                    return;
                }
                // toastr.error(response.data.message, 'Academy Error');
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    console.error(error);
                }, 2000)
            });
        },
        getCourseContent(){
            let $this = this,route;
            $this.loaded = false
            route = this.router.resolve({
                name:'courses-content-guest',
                params:{
                    course:$this.route.params.course
                }
            });
            if($this.userStore.user.id){
                route = this.router.resolve({
                    name:'courses-content',
                    params:{
                        course:$this.route.params.course
                    }
                });
            }
            axios.post(
                route.href
            ).then(function(response) {

                let content = response.data.data;
                $this.content = content;
                $this.rating.total = content.avarage_rating.total_rating
                $this.rating.count = content.avarage_rating.number_of_rating
                $this.avarage_rating = $this.avarage(content.avarage_rating.total_rating/content.avarage_rating.number_of_rating)
                $this.reviewed = content.has_reviewed
                $this.loaded = true
                $this.getLastPlayedVideo($this.route.params.course)
                return;
            }).catch(function(error) {
                console.log(error)
                setTimeout(() => {
                    console.error(error.response.data.response_msg);
                }, 2000)
            });

        },
        buyFreeCourse(slug,cost,is_free){
            this.course_name = slug
            cost = parseInt(cost);
            cost = Math.round(cost);
            if(cost <= 0 || is_free){
                let $this = this;
                const route = this.router.resolve({
                    name:'purchase-free-course',
                    params:{
                        course:slug
                    }
                });
                axios.post(
                    route.href
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    // toastr.success(response.data.message, 'Success!');
                    $this.router.push({name: 'courses-content',
                        params:{
                            course:slug
                        }
                    });
                    return
                }).catch(function(error) {
                    setTimeout(() => {
                        console.log(error.response.data.response_msg);
                        // toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            }
        },
        adminGetUserCourses(){
            let $this = this;
            const route = $this.router.resolve({
                name:'admin-user-courses',
                params:{
                    user:$this.userSelected
                },
                query:{
                    page:$this.currentPage,
                    limit:$this.itemPerPage
                }
            });
            axios.post(
                route.href
            ).then((response)=>{
                $this.isLoading = false;
                if (response.data.error == true) {
                    // error.error = response.data.error;
                    // error.message = response.data.message;
                    return;
                }
                $this.items = response.data.data;
                $this.isLoading = false;
            }).catch((error) => {
                $this.isLoading = false;
                console.log(error);
            });
        }
    },
    getters: {
    },
})
